var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasskeys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3 20v-2.35c0-.633.158-1.175.475-1.625A3.05 3.05 0 0 1 4.7 15c1.117-.5 2.188-.875 3.212-1.125a12.98 12.98 0 0 1 4.35-.313c.409.042.83.105 1.263.188a4.94 4.94 0 0 0 .537 2.737A4.797 4.797 0 0 0 16 18.5V20H3Zm16 3.675-1.5-1.5v-4.65a3.445 3.445 0 0 1-1.8-1.238c-.467-.608-.7-1.312-.7-2.112 0-.967.342-1.792 1.025-2.475.683-.683 1.508-1.025 2.475-1.025s1.792.342 2.475 1.025A3.372 3.372 0 0 1 22 14.175a3.31 3.31 0 0 1-.637 2c-.425.583-.963 1-1.613 1.25l1.25 1.25-1.5 1.5 1.5 1.5-2 2ZM11 11.5c-1.05 0-1.938-.362-2.663-1.087C7.614 9.686 7.25 8.8 7.25 7.75s.362-1.938 1.087-2.663C9.064 4.364 9.95 4 11 4s1.938.362 2.663 1.087c.724.726 1.087 1.613 1.087 2.663s-.362 1.938-1.087 2.663C12.936 11.136 12.05 11.5 11 11.5Zm7.5 3.175c.283 0 .52-.096.713-.287s.287-.43.287-.713-.096-.52-.287-.713-.43-.287-.713-.287-.52.096-.713.287-.287.43-.287.713.096.52.287.713.43.287.713.287Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasskeys);
export default __webpack_public_path__ + "static/media/passkeys.48c544f85c41bc6d9de0ab19471635c7.svg";
export { ForwardRef as ReactComponent };